package pl.mothdigital.neuronowi.theme

import com.varabyte.kobweb.silk.theme.colors.*
import pl.mothdigital.neuronowi.theme.palette.*

object SiteTheme {
    val red: ColorPalette = NeuronowiRed
    val blue: ColorPalette = NeuroNowiBlue
    val green: ColorPalette = NeuroNowiGreen
    val gray: ColorPalette = GrayPalette
    val white: ColorPalette = WhitePalette
    val black: ColorPalette = BlackPalette
}

